<template>
  <div>
    <van-cell-group>
      <van-field
        v-model="content"
        label="留言"
        type="textarea"
        placeholder="请输入您的建议"
        autosize
        :border="false"
        style="min-height:150px;"
      />
    </van-cell-group>
     <van-row type="flex" justify="center" class="row-common">
      <van-col span="23" class="col-common">
        <p style="padding:5px;color:red;">投诉电话：0795-8611810<p/>
      </van-col>
    </van-row>
    <van-button type="primary" size="large" @click="submitSuggestion">
      提交
    </van-button>
  </div>
</template>

<script type="text/javascript">

import { addSuggestion } from '@/api/other'
import { Toast } from 'vant'
export default {
  components: {},
  data() {
    return {
      content: ''
    }
  },
  methods: {
    // 提交
    submitSuggestion() {
      const webUserId = this.$store.getters.webUserInfo.id // 用户id
      if (!webUserId) { return }
      if (!this.content) {
        Toast.fail('内容不能为空')
        return
      }
      addSuggestion({
        webUserId: webUserId, // 用户id
        content: this.content // 内容
      }).then(() => {
        Toast.success('提交成功')
        setTimeout(() => {
          // 跳转页面
          this.$router.push({
            path: '/'
          })
        }, 1500)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
